import { render } from "./returnDishesModel.vue?vue&type=template&id=47e168ae"
import script from "./returnDishesModel.vue?vue&type=script&lang=js"
export * from "./returnDishesModel.vue?vue&type=script&lang=js"

import "./returnDishesModel.vue?vue&type=style&index=0&id=47e168ae&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__